import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddAccount from "./AddAccount";
import GetAllAccount from "./getAllAccount";

const Account = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  const refreshList = () => {
    setAddModalOpen(false);
    setRefreshKey((k) => k + 1);
  };

  const addButton = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setAddModalOpen(true)}
      style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", fontWeight: 600 }}
    >
      Add Account
    </Button>
  );

  return (
    <div>
      <Modal
        title="Add Account"
        open={addModalOpen}
        onCancel={() => setAddModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <AddAccount inModal onSuccess={refreshList} onCancel={() => setAddModalOpen(false)} />
      </Modal>
      <GetAllAccount refreshTrigger={refreshKey} addAccountButton={addButton} />
    </div>
  );
};

export default Account;
